var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearningSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455 455",
    style: {
      enableBackground: "new 0 0 455 455"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2EBD9"
    },
    points: "82.5,90 82.5,365 227.5,385 372.5,365 372.5,90 227.5,70  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M372.5,30v60h-290V30c0-16.5,13.5-30,30-30h230C359,0,372.5,13.5,372.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M372.5,365v60c0,16.5-13.5,30-30,30h-230c-16.5,0-30-13.5-30-30v-60H372.5z M242.5,410   c0-8.28-6.72-15-15-15s-15,6.72-15,15c0,8.29,6.72,15,15,15S242.5,418.29,242.5,410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#185F8D"
    },
    d: "M252.5,52.505c-0.001,0-50.001-0.006-50.001-0.006c-4.142-0.001-7.5-3.358-7.499-7.501   c0-4.142,3.358-7.499,7.5-7.499c0.001,0,50.001,0.006,50.001,0.006c4.142,0.001,7.5,3.358,7.499,7.501   C260,49.148,256.642,52.505,252.5,52.505z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#185F8D"
    },
    cx: 227.5,
    cy: 410.002,
    r: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2484B"
    },
    points: "177.5,247.57 177.5,327.5 227.5,327.5 247.5,227.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD1515"
    },
    d: "M227.55,227.57c-0.02-0.02-0.03,9.95-0.05,9.93v90h50v-79.93L227.55,227.57z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#274B6D"
    },
    points: "227.5,127.5 248.33,177.5 227.5,187.5 206.67,177.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC75"
    },
    d: "M277.5,247.5v0.07c-5.61,3.24-12.28,5.12-19.44,5.12c-12.84,0-24.11-6.04-30.51-15.12   c-0.02-0.02-0.03-0.05-0.05-0.07c-6.39,9.12-17.69,15.19-30.56,15.19c-7.16,0-13.83-1.88-19.44-5.12v-0.07l29.17-70h41.66   L277.5,247.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningSvgrepoCom);
export default __webpack_public_path__ + "static/media/learning-svgrepo-com.370db2e71beb6274b88e761dfb4d4727.svg";
export { ForwardRef as ReactComponent };